import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=197245a0&scoped=true"
import script from "./Close.vue?vue&type=script&lang=ts"
export * from "./Close.vue?vue&type=script&lang=ts"
import style0 from "./Close.vue?vue&type=style&index=0&id=197245a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197245a0",
  null
  
)

export default component.exports